import React from "react";
import { randomDomId } from "../utils";

export function Switcher({ value = false, onClick, className = "" }) {

    const id = randomDomId();

    return (
        <div className={`oct_switch-wrapper-v2 ${className}`}>
            <input
                type="checkbox"
                checked={value}
                onChange={() => onClick && onClick(!value)}
                className="oct_switch-input-v2"
                id={`switcher${id}`}
            />
            <label
                htmlFor={`switcher${id}`}
                className={`oct_switch-track-v2 ${value ? 'checked' : ''}`}
            >
                <span className="oct_switch-thumb-v2" />
            </label>
        </div>
    )
}
